import * as React from 'react';

const SVGTransferPending: React.SFC<SvgProps> = props => (
  <svg
    width={300}
    height={236}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path id="a" d="M0 237h300.09V.914H0z" />
      <path id="c" d="M.776.616h43.868V33H.776z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M253.54.205s-44.29.419-33.794 51.228c13.233 64.062-59.716-29.04-135.238 40.519-48.767 44.915 10.377 95.564-48.698 117.944C4.465 221.77 0 235.99 0 235.99l300.076-.013L300.09 0 253.54.205z"
        fill="#DEEDF2"
      />
      <path fill="#FC3" d="M29.707 148.833l-9.05-9.05 9.05-9.05 9.05 9.05z" />
      <g transform="translate(0 -.914)">
        <path
          d="M226.827 31.8a8.095 8.095 0 1 1-16.19 0 8.094 8.094 0 1 1 16.19 0"
          fill="#1BB3BE"
        />
        <path
          d="M257.796 147.8c0 3.9-3.228 7.062-7.209 7.062-3.98 0-7.208-3.162-7.208-7.063 0-3.9 3.228-7.063 7.208-7.063 3.981 0 7.21 3.162 7.21 7.063"
          fill="#C3DEE7"
        />
        <path
          d="M47.72 100.593c0 3.9-3.228 7.063-7.209 7.063-3.98 0-7.208-3.162-7.208-7.063s3.228-7.063 7.208-7.063c3.981 0 7.21 3.162 7.21 7.063"
          fill="#C3DEE7"
        />
        <path
          d="M106.035 216.907c0 3.901-3.227 7.063-7.208 7.063-3.98 0-7.208-3.162-7.208-7.063 0-3.9 3.228-7.063 7.208-7.063s7.208 3.162 7.208 7.063"
          fill="#FFF"
        />
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#C3DEE7"
          mask="url(#b)"
          d="M250.698 109.536h15.732V93.803h-15.732z"
        />
      </g>
      <g fill="#F9C8BC">
        <path d="M99.435 164.071l42.45 36.074s13.22 10.123 26.227 1.324l58.136-18.93s3.43-21.102-.984-33.63l-27.788-38.47-98.04 53.632z" />
        <path d="M225.508 150.09L211.795 95.2l-22.649 4.387 14.166 57.022z" />
        <path d="M219.243 172.216l42.514 63.672h-82.005l-23.048-31.604z" />
      </g>
      <path
        d="M100.272 164.28l24.489 9.272 13.059 19.588s4.274 5.817 15.433 1.78l58.766-33.715s6.767-5.936 1.304-12.646l-44.824-16.565-68.227 32.287z"
        fill="#F9BEB0"
      />
      <path
        fill="#F9BEB0"
        d="M75.788 106.307l20.463 16.81 15.347-10.72-16.566-15.59z"
      />
      <path
        fill="#F9BEB0"
        d="M82.75 124.509l18.272 14.86 14.372-11.206-15.833-14.13z"
      />
      <path
        fill="#F9BEB0"
        d="M89.502 143.267l16.565 16.078 14.13-9.014-14.86-17.052z"
      />
      <path
        d="M190.079 102.94l6.88 2.94s10.405 21.473 16.364 36.102l-9.014 3.897-14.23-42.938z"
        fill="#F9BEB0"
      />
      <g transform="translate(157 203.086)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          fill="#F9BEB0"
          mask="url(#d)"
          d="M.776 2.19L14.149.616 44.644 33l-21.255-.04z"
        />
      </g>
      <g>
        <path
          d="M152.338 187.935l52.098-29.809c5.447-3.117 7.461-9.938 4.473-15.158L141.832 25.584c-2.987-5.219-9.888-6.94-15.335-3.823L74.4 51.57c-5.448 3.116-7.46 9.937-4.475 15.157l67.078 117.384c2.987 5.22 9.888 6.941 15.335 3.824"
          fill="#9E3667"
        />
        <path
          d="M155.677 186.117l52.098-29.81c5.447-3.116 7.457-9.942 4.466-15.168L145.083 23.614c-2.99-5.226-9.893-6.952-15.342-3.835L77.645 49.588c-5.448 3.116-7.458 9.943-4.468 15.169l67.158 117.525c2.99 5.226 9.895 6.952 15.342 3.835"
          fill="#FFF"
        />
        <path
          d="M155.677 186.117l52.098-29.81c5.447-3.116 7.61-9.674 4.807-14.573l-62.95-110.171c-2.804-4.9-9.555-6.357-15.002-3.24L82.532 58.132c-5.447 3.116-7.61 9.675-4.807 14.574l62.951 110.17c2.803 4.9 9.554 6.358 15.001 3.24"
          fill="#DEEDF2"
        />
        <path
          d="M92.649 45.86a1.448 1.448 0 1 0 2.88-.31 1.448 1.448 0 0 0-2.88.31"
          fill="#9BC3D3"
        />
        <path
          d="M115.344 32.9a1.446 1.446 0 1 0 2.876-.308 1.446 1.446 0 0 0-2.876.307"
          fill="#9BC3D3"
        />
        <path
          d="M120.065 30.454a1.447 1.447 0 1 0 2.877-.31 1.447 1.447 0 0 0-2.877.31"
          fill="#9BC3D3"
        />
        <path
          d="M103.316 41.777l9.45-5.238a1.257 1.257 0 0 0 .489-1.705 1.258 1.258 0 0 0-1.705-.49l-9.451 5.239a1.258 1.258 0 0 0-.488 1.705 1.257 1.257 0 0 0 1.705.489"
          fill="#9BC3D3"
        />
        <path
          d="M137.076 33.038L85.218 62.765c-5.522 3.165-7.437 10.204-4.28 15.73l59.218 103.597 71.875-41.202-59.203-103.567c-3.163-5.537-10.22-7.456-15.752-4.285"
          fill="#FFF"
        />
        <path
          fill="#EC0000"
          d="M83.938 83.867l72.536-40.201-3.359-6.061-72.536 40.2z"
        />
        <path
          fill="#9BC3D3"
          d="M103.306 90.568l16.905-9.37-2.38-4.292-16.904 9.369z"
        />
        <path
          fill="#D2F0F2"
          d="M141.392 161.188l26.778-14.841-1.026-1.852-26.778 14.84z"
        />
        <path
          fill="#C3DEE7"
          d="M137.95 155.335l54.439-30.17-1.027-1.853-54.438 30.17z"
        />
        <path
          d="M195.238 137.892l-50.576 28.298"
          stroke="#DEEDF2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M134.78 78.695L106.592 94.49"
          stroke="#DEEDF2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g fill="#F9C8BC">
        <path d="M119.018 150.264l-24.62-4.12a8.818 8.818 0 0 1-7.242-10.155 8.819 8.819 0 0 1 10.154-7.244l24.62 4.121a8.82 8.82 0 0 1 7.243 10.155 8.82 8.82 0 0 1-10.155 7.243" />
        <path d="M118.392 168.044l-15.687-2.558a8.821 8.821 0 0 1-7.243-10.155 8.821 8.821 0 0 1 10.156-7.243l15.686 2.558a8.82 8.82 0 0 1 7.243 10.155 8.82 8.82 0 0 1-10.155 7.243" />
        <path d="M103.942 130.006l-15.687-2.558a8.821 8.821 0 0 1-7.243-10.155 8.821 8.821 0 0 1 10.156-7.243l15.686 2.558a8.82 8.82 0 0 1 7.243 10.155 8.82 8.82 0 0 1-10.155 7.243" />
        <path d="M85.884 110.046l-4.879-.93a8.82 8.82 0 0 1 2.912-17.398l4.88.93a8.82 8.82 0 0 1 7.242 10.155 8.82 8.82 0 0 1-10.155 7.243" />
        <path d="M175.171 76.448c-4.094 9.37.251 19.703 9.587 23.872l13.61 5.791c4.88 2.178 10.603-.012 12.782-4.892 2.178-4.88-.012-10.603-4.892-12.782L177.31 75.805s-1.582-.63-2.138.643" />
        <path d="M211.994 97.334c0 5.362-4.347 9.708-9.708 9.708s-9.708-4.346-9.708-9.708c0-5.36 4.347-9.708 9.708-9.708 5.36 0 9.708 4.347 9.708 9.708" />
      </g>
      <path
        fill="#FFF"
        d="M164.084 221.942l6.73 14.063 20.927.072 65.521-23.387-11.06-25.484z"
      />
      <path fill="#1BB3BE" d="M191.772 236.078l80.161-.04-14.729-23.435z" />
      <g>
        <path
          d="M246.235 206.52a6.228 6.228 0 1 1-12.456 0 6.228 6.228 0 0 1 12.456 0"
          fill="#9BC3D3"
        />
        <path
          d="M246.408 205.496a5.917 5.917 0 1 1-11.834 0 5.917 5.917 0 0 1 11.834 0"
          fill="#D2F0F2"
        />
        <path fill="#9BC3D3" d="M231.336 190.471l14.865-3.266-13.414 5.587z" />
        <path
          d="M143.541 124.326l6.673-11.252 13.847.01s2.764 2.047 3.422 3.03l-23.23 12.728s-.85-3.181-.711-4.516"
          fill="#C3DEE7"
        />
        <path
          d="M136.852 106.306l15.084-8.264s.511 5.168-1.182 8.54l-5.53 3.03s-5.772-.843-8.372-3.306"
          fill="#C3DEE7"
        />
        <path
          d="M167.484 116.114l-3.423-3.03a27.759 27.759 0 0 0-13.306-6.503 30.308 30.308 0 0 0 1.916-14.047l-.426-4.234c-.231-.422-23.232 12.728-23.232 12.728l3.34 2.639a30.307 30.307 0 0 0 12.87 5.945 27.75 27.75 0 0 0-1.681 14.714l.71 4.516s23.233-12.733 23.232-12.728z"
          stroke="#9BC3D3"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.398 101.53l25.6-14.027"
          stroke="#9BC3D3"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.827 129.69l25.6-14.027"
          stroke="#9BC3D3"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default SVGTransferPending;
